export const LEVEL_LIST: LevelItem[] = [
    {
        name: '时尚无冕之王1',
        id: '30000',
        day: 625,
        week: 1250,
        count: 45
    },
    {
        name: '时尚无冕之王2',
        id: '29999',
        day: 580,
        week: 1160,
        count: 44
    },
    {
        name: '时尚无冕之王3',
        id: '29998',
        day: 550,
        week: 1100,
        count: 43
    },
    {
        name: '引领潮流之巅3',
        id: '29992',
        day: 500,
        week: 1000,
        count: 42
    },
    {
        name: '引领潮流之巅2',
        id: '29951',
        day: 450,
        week: 900,
        count: 37

    },
    {
        name: '引领潮流之巅1',
        id: '29901',
        day: 400,
        week: 800,
        count: 32
    },
    {
        name: '首席创意之星3',
        id: '29851',
        day: 350,
        week: 700,
        count: 28
    },
    {
        name: '首席创意之星2',
        id: '29801',
        day: 300,
        week: 600,
        count: 26
    },
    {
        name: '首席创意之星1',
        id: '29701',
        day: 275,
        week: 550,
        count: 22
    },
    {
        name: '流行缔造大师3',
        id: '29601',
        day: 250,
        week: 500,
        count: 20
    },
    {
        name: '流行缔造大师2',
        id: '29501',
        day: 225,
        week: 450,
        count: 19
    },
    {
        name: '流行缔造大师1',
        id: '29401',
        day: 200,
        week: 400,
        count: 18
    },
    {
        name: '时尚契合者3',
        id: '29201',
        day: 180,
        week: 360,
        count: 16
    },
    {
        name: '时尚契合者2',
        id: '29001',
        day: 160,
        week: 320,
        count: 15
    },
    {
        name: '时尚契合者1',
        id: '28801',
        day: 150,
        week: 300
    },
    {
        name: '风尚先遣者3',
        id: '28601',
        day: 145,
        week: 290
    },
    {
        name: '风尚先遣者2',
        id: '28401',
        day: 140,
        week: 280
    },
    {
        name: '风尚先遣者1',
        id: '28201',
        day: 135,
        week: 270
    },
    {
        name: '前卫传递者3',
        id: '28001',
        day: 130,
        week: 260
    },
    {
        name: '前卫传递者2',
        id: '27501',
        day: 125,
        week: 250
    },
    {
        name: '前卫传递者1',
        id: '27001',
        day: 120,
        week: 240
    },
    {
        name: '首席设计师3',
        id: '26001',
        day: 115,
        week: 230
    },
    {
        name: '首席设计师2',
        id: '25001',
        day: 110,
        week: 220
    },
    {
        name: '首席设计师1',
        id: '24001',
        day: 105,
        week: 210
    },
    {
        name: '色彩创意师3',
        id: '22001',
        day: 100,
        week: 200
    },
    {
        name: '色彩创意师2',
        id: '20001',
        day: 95,
        week: 190
    },
    {
        name: '色彩创意师1',
        id: '18001',
        day: 90,
        week: 180
    },
    {
        name: '新人设计师3',
        id: '15001',
        day: 85,
        week: 170
    },
    {
        name: '新人设计师2',
        id: '10001',
        day: 80,
        week: 160
    },
    {
        name: '新人设计师1',
        id: '1',
        day: 75,
        week: 150
    },
]

export const JJC_Strategies = [
    {
        describe: '周一打15次,周二打5次，周三~周日留2打3',
        id: 'free',
        name: '不买次数'
    },
    {
        describe: '周一买次数打到周结算段位,周二打5次，周三~周日留2打3',
        id: 'buyMaxCount',
        name: '买次数到结算段位',
    },
    {
        describe: '买次数到需求段位',
        id: 'buySuitableCount',
        name: '按需求规划',
    },
]